import { NgModule } from '@angular/core';
import { LibFillCrossRoundIconComponent } from './lib-fill-cross-round-icon.component';

@NgModule({
  declarations: [LibFillCrossRoundIconComponent],
  exports: [LibFillCrossRoundIconComponent],
})
export class LibFillCrossRoundIconModule {}
